<template>
  <div>
    <v-row no-gutters>
      <v-spacer />
      <v-btn
        class="mx-2 primary"
        @click="$refs.dialog.show()"
        :disabled="tagMode"
      >
        <v-icon left>mdi-upload</v-icon> Upload
      </v-btn>
      <v-btn
        class="mx-2 primary"
        @click="tagMode = !tagMode"
        :disabled="!content.src"
      >
        <v-icon left>mdi-plus</v-icon>Tag
      </v-btn>
      <v-spacer />
    </v-row>
    <v-card
      v-if="content.src"
      max-width="600px"
      class="mx-auto my-4"
    >
      <FbPicture
        :src="content.src"
        :tags="content.tags"
        :tag-mode="tagMode"
        :edit-mode="true"
        @tag="addTag"
        @delete="deleteTag"
        style="overflow: hidden" />
    </v-card>
    <p v-else class="text-center mt-4">No picture yet</p>
    <p v-if="tagMode" class="text-center">Click and drag on image to tag</p>
    <ImageUploadDialog ref="dialog" @upload="onUpload" />
  </div>
</template>

<script>
import FbPicture from '../components/FbPicture'
import ImageUploadDialog from '../components/ImageUploadDialog'

export default {
  name: 'FbStatusContentEditorPicture',
  components: {
    FbPicture,
    ImageUploadDialog
  },
  props: {
    content: Object
  },
  data() {
    return {
      tagMode: false
    }
  },
  methods: {
    onUpload(url) {
      this.content.src = url
      this.content.tags = []
    },
    addTag(tag) {
      if (this.content.tags == null)
        this.content.tags = []
      this.content.tags.push(tag)
      this.tagMode = false
    },
    deleteTag(tag) {
      const tags = this.content.tags.filter(t => t !== tag)
      this.content.tags = tags
    }
  }
}
</script>